import React, { useCallback, useEffect, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Select from 'components/inputs/Select';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { CREATE_MULTIPLE_VEHICLE, UPDATE_MULTIPLE_VEHICLE, CREATE_VEHICLE, GET_VEHICLE, UPDATE_VEHICLE } from 'actions/vehicle';
import { GET_STATION_BY_CITY } from 'actions/chargingStation';
import { FETCH_USER } from 'actions/user';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import { FETCH_VEHICLE_MAKE } from 'actions/vehicleMake';
import { FETCH_VEHICLE_MODEL } from 'actions/vehicleModel';
// import moment from 'moment';
// import DatePickerInput from 'components/inputs/DatePickerInput';
import { CREATE_STATUS_CODE, GET_ADD_ONS, GET_VEHICLES, MANAGE_ADD_ONS, MANAGE_VEHICLES, UPDATE_STATUS_CODE } from 'components/common/constant';
import * as XLSX from 'xlsx';
import { setShowErrorToast } from 'utils/api';
import { toast } from 'react-toastify';
import FileSaver from 'file-saver';
import { GiSwipeCard } from 'react-icons/gi';
import { useTranslation } from 'react-i18next';
import Footer from 'components/general/Footer';
import { NavContext } from 'components/privateRoute/PrivateRoute';

const VehicleForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const history = useHistory();
  const { navigateTo } = useContext(NavContext);

  const { vehicleId } = useParams();

  const vehicleDetail = useSelector((state) => state.vehicle.vehicleDetail);
  const allVehicleMake = useSelector((state) => state.vehicleMake.vehicleMakes);
  const allVehicleModel = useSelector((state) => state.vehicleModel.vehicleModels);
  // const allUserData = useSelector((state) => state.user.users);
  const profileDetail = useSelector((state) => state.profile.userProfile);
  const tenantId = _.get(profileDetail, 'tenant', '');
  const makePage = useSelector((state) => state.vehicleMake.page);
  const modelPage = useSelector((state) => state.vehicleModel.page);
  const makeTotalPage = useSelector((state) => state.vehicleMake.totalPages);
  const modelTotalPage = useSelector((state) => state.vehicleModel.totalPages);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const allStationByCity = useSelector((state) => state.stationByCity.stationByCities);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const currentUserName = _.get(profileData, 'name', '');

  const stationList =
    userProfileStations && userProfileStations.length > 0
      ? allStationByCity.filter((x) => userProfileStations.indexOf(x.id) !== -1)
      : allStationByCity;

  const sampleVehicleList = [
    {
      // name: '',
      rto_no: '',
      RFID: '',
      // picture: '',
      make: '',
      model: '',
      type: '',
      charging_station: '',
      // owner: '',
      // max_charging_capacity: '',
      // insurance_expiry: '',
      // documents: [],
      // ownership_type: '',
    },
  ];

  const VehicleSchema = Yup.object().shape({
    // name: Yup.string().required('Vehicle name is required!'),
    type: Yup.string().required(t('vehicleForm.type')),
    make: Yup.string().required(t('vehicleForm.make')),
    model: Yup.string().required(t('vehicleForm.model')),
    rto_no: Yup.string()
      .required(t('vehicleForm.rtoNo'))
      .strict(true)
      .trim(t('vehicleForm.space'))
      .matches(/^[A-Za-z0-9\s]+$/, t('vehicleForm.matchNumAlpha'))
      .max(100, t('vehicleForm.maxlimit')),
    RFID: Yup.string()
      .required(t('vehicleForm.rfid'))
      .strict(true)
      .trim(t('vehicleForm.space'))
      // .matches(/^[A-Za-z0-9\s]+$/, t("vehicleForm.matchNumAlpha"))
      .max(100, t('vehicleForm.maxlimit')),
  });

  const initialValues =
    vehicleId && !_.isEmpty(vehicleDetail)
      ? {
          ...vehicleDetail,
          // owner: _.get(vehicleDetail, 'owner.id', ''),
          tenant: _.get(vehicleDetail, 'tenant.id', ''),
          ownership_type: _.get(vehicleDetail, 'ownership_type', 'b2b'),
          vin_num: _.get(vehicleDetail, 'vin_num', '').toString(),
          evcatalog: _.get(vehicleDetail, 'evcatalog.id', ''),
          // insurance_expiry: moment(_.get(vehicleDetail, 'insurance_expiry')).utcOffset(0, true).format('YYYY-MM-DD'),
        }
      : {
          vin_num: '',
          // name: '',
          type: '',
          make: '',
          model: '',
          charging_station: '',
          rto_no: '',
          RFID: '',
          max_charging_capacity: '',
          // insurance_expiry: moment(),
          // owner: '',
          documents: [],
          ownership_type: 'b2b',
          // picture: 'http://jbsdjcj.png',
          evcatalog: '',
        };

  const getVehicleDetails = useCallback((id) => {
    dispatch({ type: GET_VEHICLE.REQUEST, payload: id });
  }, []);

  const getAllUsers = useCallback((data) => {
    dispatch({ type: FETCH_USER.REQUEST, payload: data ? data : {} });
  }, []);

  useEffect(() => {
    if (vehicleId) {
      getVehicleDetails(vehicleId);
    }
  }, [vehicleId]);

  const addVehicle = useCallback((data) => {
    dispatch({
      type: CREATE_VEHICLE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          setTimeout(() => {
            navigateTo('/vehicles');
          }, 1000);
        }
      },
    });
  }, []);

  const addMultipleVehicle = useCallback((data) => {
    setShowErrorToast(false);
    dispatch({
      type: CREATE_MULTIPLE_VEHICLE.REQUEST,
      payload: data,
      cb: (res) => {
        setShowErrorToast(true);
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          toast.success('Vehicle added successfully');
          setTimeout(() => {
            navigateTo('/vehicles');
          }, 1000);
        } else {
          const message = _.get(res, 'data.message') || _.get(res, 'message') || 'Failed to import vehicles.';
          const errors = _.get(res, 'data.errors', []);
          if (errors.length) {
            const errorText = errors
              .map((e) => (typeof e === 'object' ? `Row ${e.row}: ${e.message}` : e))
              .join(', ');
            toast.error(errorText);
          } else {
            toast.error(message);
          }
        }
      },
    });
  }, []);

  const updateMultipleVehicleAction = useCallback((data) => {
    setShowErrorToast(false);
    dispatch({
      type: UPDATE_MULTIPLE_VEHICLE.REQUEST,
      payload: data,
      cb: (res) => {
        setShowErrorToast(true);
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          toast.success('Vehicles updated successfully');
          const warnings = _.get(res, 'data.warnings', []);
          if (warnings.length) {
            const warningText = warnings.map((w) => `Row ${w.row}: ${w.message}`).join(', ');
            toast.info(warningText);
          }
          setTimeout(() => {
            navigateTo('/vehicles');
          }, 1000);
        } else {
          const message = _.get(res, 'data.message') || _.get(res, 'message') || 'Failed to update vehicles.';
          const errors = _.get(res, 'data.errors', []);
          if (errors.length) {
            const errorText = errors
              .map((e) => (typeof e === 'object' ? `Row ${e.row}: ${e.message}` : e))
              .join(', ');
            toast.error(errorText);
          } else {
            toast.error(message);
          }
        }
      },
    });
  }, []);

  const editVehicleDetail = useCallback((data) => {
    dispatch({
      type: UPDATE_VEHICLE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          setTimeout(() => {
            navigateTo('/vehicles');
          }, 500);
        }
      },
    });
  }, []);

  const getAllVehicleMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MAKE.REQUEST, payload: data });
  }, []);

  const getVehicleModelByMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MODEL.REQUEST, payload: data });
  }, []);

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      // access_type: 'Public',
    };
    dispatch({ type: GET_STATION_BY_CITY.REQUEST, payload: stationData });
  }, []);

  const getAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_ADD_ONS),
      (data) => data.name
    );

  const manageAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_ADD_ONS),
      (data) => data.name
    );

  const getVehiclePermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_VEHICLES),
      (data) => data.name
    );

  const manageVehiclePermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_VEHICLES),
      (data) => data.name
    );

  useEffect(() => {
    getAllVehicleMake({ limit: 999 });
    getAllUsers();
    getAllStation();
  }, []);

  useEffect(() => {
    if (vehicleId && !_.isEmpty(vehicleDetail) && !_.isEmpty(allVehicleMake)) {
      const selectedMake = _.find(allVehicleMake, { name: _.get(vehicleDetail, 'make', '') });
      if (selectedMake && !_.isEmpty(selectedMake) && _.has(selectedMake, 'id')) {
        getVehicleModelByMake({ makeId: selectedMake.id });
      }
    }
  }, [vehicleId, vehicleDetail, allVehicleMake]);
  const upload = () => {
    const fileUpload = document.getElementById('fileUpload');

    if (!fileUpload.files || fileUpload.files.length === 0) {
      toast.error('Please select a file to upload.');
      return;
    }

    const file = fileUpload.files[0];
    const fileName = file.name.toLowerCase();
    const isValidExt = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

    // reset so re-selecting the same file triggers onChange again
    fileUpload.value = '';

    if (isValidExt) {
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = () => processExcel(reader.result);
          reader.onerror = () => toast.error('Failed to read file.');
          reader.readAsBinaryString(file);
        } else {
          toast.error('This browser does not support HTML5.');
        }
      } else {
        toast.error('This browser does not support HTML5.');
      }
    } else {
      toast.error('Please upload a valid Excel file (.xls or .xlsx).');
    }
  };

  const processExcel = (data) => {
    try {
      const workbook = XLSX.read(data, { type: 'binary' });
      const firstSheet = workbook.SheetNames[0];
      const excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
      if (!excelRows.length) {
        toast.error('Excel file is empty. Please use the sample template.');
        return;
      }
      _.map(excelRows, (row) => {
        row.documents = [];
        row.max_charging_capacity = '10';
        row.model = row.model !== undefined && row.model !== null ? row.model.toString() : '';
        row.ownership_type = 'b2b';
        const raw = row.charging_station;
        row.charging_station =
          raw !== undefined && raw !== null && raw !== ''
            ? String(raw)
                .replace(/[[\]'"]/g, '')
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
            : [];
      });
      addMultipleVehicle(excelRows);
    } catch (err) {
      toast.error('Failed to read Excel file. Please use the sample template.');
    }
  };

  const uploadEdit = () => {
    const fileUploadEdit = document.getElementById('fileUploadEdit');

    if (!fileUploadEdit.files || fileUploadEdit.files.length === 0) {
      toast.error('Please select a file to upload.');
      return;
    }

    const file = fileUploadEdit.files[0];
    const fileName = file.name.toLowerCase();
    const isValidExt = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

    // reset so re-selecting the same file triggers onChange again
    fileUploadEdit.value = '';

    if (isValidExt) {
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = () => processExcelEdit(reader.result);
          reader.onerror = () => toast.error('Failed to read file.');
          reader.readAsBinaryString(file);
        } else {
          toast.error('This browser does not support HTML5.');
        }
      } else {
        toast.error('This browser does not support HTML5.');
      }
    } else {
      toast.error('Please upload a valid Excel file (.xls or .xlsx).');
    }
  };

  const processExcelEdit = (data) => {
    try {
      const workbook = XLSX.read(data, { type: 'binary' });
      const firstSheet = workbook.SheetNames[0];
      const excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
      if (!excelRows.length) {
        toast.error('Excel file is empty. Please use the sample template.');
        return;
      }
      // Strip empty cells per row so the backend can preserve untouched DB values.
      // Do NOT inject create-only defaults (max_charging_capacity, documents, ownership_type)
      // — those are valid only when creating a new vehicle.
      const cleaned = _.map(excelRows, (row) => {
        const out = {};
        _.forEach(row, (value, key) => {
          if (value === undefined || value === null) return;
          if (typeof value === 'string' && value.trim() === '') return;
          if (key === 'charging_station') {
            const parsed = String(value)
              .replace(/[[\]'"]/g, '')
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);
            if (parsed.length) out.charging_station = parsed;
            return;
          }
          if (key === 'model') {
            out.model = String(value);
            return;
          }
          out[key] = value;
        });
        return out;
      });
      updateMultipleVehicleAction(cleaned);
    } catch (err) {
      toast.error('Failed to read Excel file. Please use the sample template.');
    }
  };

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const downloadSampleVehicleList = (file, fileName) => {
    // download static Excel file
    const ws = XLSX.utils.json_to_sheet(file);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={`${vehicleId ? 'Edit' : 'Add'} ${t('header.vehicle')}`} backTo="/vehicles" />
        <div className="page-content-wrapper scrollable">
          <div className="add-vehicle-page-main">
            <Card className="vehicle-form-card">
              <div className="vehicle-form__block">
                <Formik
                  enableReinitialize={!!vehicleId}
                  initialValues={initialValues}
                  validationSchema={VehicleSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    if (vehicleId) {
                      // edit tenant api call....
                      const editVehicleData = _.omit(values, ['rfid_object', 'is_default', 'unit_consumed', 'anpr_enabled', 'evmasterdata', 'verify_request','evcatalog',]);
                      const selectedVehicle = _.find(allVehicleModel, { model: values.model });
                      editVehicleDetail({
                        ...editVehicleData,
                        // delete below tenant, when vehicle-data have the tenant-data
                        tenant: values.tenant ? values.tenant : tenantId,
                        max_charging_capacity: selectedVehicle.max_charging_capacity.toString(),
                      });
                    } else {
                      //add tenant api call...
                      const selectedVehicle = _.find(allVehicleModel, { model: values.model });
                      addVehicle({
                        ...values,
                        max_charging_capacity: selectedVehicle.max_charging_capacity.toString(),
                      });
                    }
                    setSubmitting(false);
                  }}
                >
                  {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="vehicle-form__inner">
                        <Row>
                          {/* <Col lg={6} md={12}>
                            <TextInput
                              label="Vehicle Name"
                              type="name"
                              value={values.name}
                              name="name"
                              onChange={handleChange}
                              error={errors.name && touched.name ? errors.name : null}
                            />
                          </Col> */}
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              label={t('addVehicleForm.vehicleType')}
                              placeholder={t('placeHolder.selectVehicleType')}
                              options={[
                                { label: 'Bus', value: 'bus' },
                                { label: 'Truck', value: 'truck' },
                                { label: 'Car', value: 'car' },
                                { label: 'Two wheeler', value: 'two wheeler' },
                                { label: 'Three wheeler', value: 'three wheeler' },
                                { label: 'Other', value: 'other' },
                              ]}
                              name="type"
                              value={values.type}
                              onChange={(val) => setFieldValue('type', val)}
                              error={errors.type && touched.type ? errors.type : null}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              className="mb-4"
                              label={t('addVehicleForm.vehicleMake')}
                              options={_.map(allVehicleMake, (item) => {
                                return { label: item.name, value: item.name };
                              })}
                              placeholder={t('placeHolder.selectMake')}
                              value={values.make}
                              name="make"
                              onMenuScrollDown={true}
                              getDataOnScrollDown={getAllVehicleMake}
                              page={makePage}
                              totalPage={makeTotalPage}
                              onChange={(val) => {
                                setFieldValue(`make`, val);
                                const currentMake = _.find(allVehicleMake, { name: val });
                                getVehicleModelByMake({ makeId: currentMake.id });
                              }}
                              error={errors.make && touched.make ? errors.make : null}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              className="mb-4"
                              placeholder={t('placeHolder.selectModel')}
                              options={_.map(allVehicleModel, (item) => {
                                return { label: item.model, value: _.find(allVehicleModel, { id: item.id }).model };
                              })}
                              label={t('addVehicleForm.vehicleModel')}
                              name="model"
                              value={values.model}
                              onMenuScrollDown={true}
                              getDataOnScrollDown={(data) => getVehicleModelByMake({ ...data, makeId: values.make })}
                              page={modelPage}
                              totalPage={modelTotalPage}
                              onChange={(val) => {
                                const currentModel = _.find(allVehicleModel, { model: val });
                                setFieldValue(`model`, _.get(currentModel, 'model', ''));
                                setFieldValue(`evcatalog`, _.get(currentModel, 'id', ''));
                              }}
                              error={errors.model && touched.model ? errors.model : null}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <Select
                              label={t('addVehicleForm.chargingStation')}
                              options={[
                                ..._.map(stationList, (station) => {
                                  return { label: station.name, value: station.id };
                                }),
                              ]}
                              placeholder={t('placeHolder.selectStation')}
                              name="charging_station"
                              isMulti
                              value={values.charging_station}
                              onMenuScrollDown={true}
                              onChange={(val) => {
                                setFieldValue(`charging_station`, val);
                              }}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <TextInput
                              isRequired
                              placeholder={t('placeHolder.vehicleRegistrationNo')}
                              label={t('addVehicleForm.vehicleRegistrationNo')}
                              name="rto_no"
                              value={values.rto_no}
                              onChange={handleChange}
                              error={errors.rto_no && touched.rto_no ? errors.rto_no : null}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <TextInput
                              isRequired
                              placeholder={t('placeHolder.rfid/ID Tag')}
                              label={t('addVehicleForm.rfid/IDTag')}
                              name="RFID"
                              value={values.RFID}
                              onChange={handleChange}
                              error={errors.RFID && touched.RFID ? errors.RFID : null}
                            />
                          </Col>
                          {/*<Col lg={6} md={12}>*/}
                          {/*  <Select*/}
                          {/*    isRequired*/}
                          {/*    label="Vehicle Owner"*/}
                          {/*    placeholder="Select owner"*/}
                          {/*    options={_.map(allUserData, (item) => {*/}
                          {/*      return { label: _.startCase(item.name), value: item.id };*/}
                          {/*    })}*/}
                          {/*    name="owner"*/}
                          {/*    value={values.owner}*/}
                          {/*    onChange={(val) => setFieldValue('owner', val)}*/}
                          {/*    error={errors.owner && touched.owner ? errors.owner : null}*/}
                          {/*  />*/}
                          {/*</Col>*/}
                          {/*<Col lg={6} md={12}>*/}
                          {/*  <Select*/}
                          {/*    isRequired*/}
                          {/*    label="Ownership Type"*/}
                          {/*    placeholder="Select ownership type"*/}
                          {/*    options={[*/}
                          {/*      { label: 'B2B', value: 'b2b' },*/}
                          {/*      { label: 'B2C', value: 'b2c' },*/}
                          {/*      { label: 'Hybrid', value: 'hybrid' },*/}
                          {/*    ]}*/}
                          {/*    name="ownership_type"*/}
                          {/*    value={values.ownership_type}*/}
                          {/*    onChange={(val) => setFieldValue('ownership_type', val)}*/}
                          {/*    error={errors.ownership_type && touched.ownership_type ? errors.ownership_type : null}*/}
                          {/*  />*/}
                          {/*</Col>*/}
                          {/*<Col lg={6} md={12}>*/}
                          {/*  <DatePickerInput*/}
                          {/*    isRequired*/}
                          {/*    label="Expiry Insurance"*/}
                          {/*    value={values.insurance_expiry}*/}
                          {/*    onChange={(dateString) => setFieldValue('insurance_expiry', dateString)}*/}
                          {/*    error={errors.insurance_expiry && touched.insurance_expiry ? errors.insurance_expiry : null}*/}
                          {/*  />*/}
                          {/*</Col>*/}
                          <Col lg={6} md={12}>
                            <TextInput
                              label={t('addVehicleForm.vinNumber')}
                              placeholder={t('placeHolder.vinNumber')}
                              name="vin_num"
                              value={values.vin_num}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {!vehicleId && (
                            <Col lg={6} md={12}>
                              <div className="import-vehicle-block">
                                <TextInput
                                  label={t('addVehicleForm.importVehicleFile')}
                                  type="file"
                                  onChange={upload}
                                  name="fileUpload"
                                  id="fileUpload"
                                />
                                <span className="download-sample--block">
                                  <div className="download-sample-file" onClick={() => downloadSampleVehicleList(sampleVehicleList, 'vehicleList')}>
                                    <GiSwipeCard color="#58d37d" size={20} />( {t('addVehicleForm.sampleList')} )
                                  </div>
                                </span>
                              </div>
                            </Col>
                          )}
                          {vehicleId && (
                            <Col lg={6} md={12}>
                              <div className="import-vehicle-block">
                                <TextInput
                                  label="Bulk Edit Vehicles (Excel)"
                                  type="file"
                                  onChange={uploadEdit}
                                  name="fileUploadEdit"
                                  id="fileUploadEdit"
                                />
                                <span className="download-sample--block">
                                  <div className="download-sample-file" onClick={() => downloadSampleVehicleList(sampleVehicleList, 'vehicleEditList')}>
                                    <GiSwipeCard color="#58d37d" size={20} />( {t('addVehicleForm.sampleList')} )
                                  </div>
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                      <div className="vehicle-save--btn--block">
                        {!_.isEmpty(manageAddOns) ||
                        (!_.isEmpty(getAddOns) && !_.isEmpty(manageAddOns)) ||
                        !_.isEmpty(manageVehiclePermissions) ||
                        (!_.isEmpty(getVehiclePermissions) && !_.isEmpty(manageVehiclePermissions)) ? (
                          <Button type="submit" className="vehicle-save-btn save--btn" disabled={isSubmitting}>
                            {vehicleId ? 'Edit' : t('button.saveAdd')} {t('button.vehicle')}
                          </Button>
                        ) : (
                          <Button className="vehicle-save-btn save--btn">{vehicleId ? 'Edit' : 'Save and Add'} Vehicle</Button>
                        )}
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Card>
          </div>
          {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};
export default VehicleForm;
